export type LoginApiName = 'phato' | 'laureano' | 'laureanoSoul' | 'hnsn';

export function isAdminLogin(login: string) {
  const normalized = login.replace(/\D/g, '');
  return normalized === '00009' || normalized === '00000';
}

export function getSuccessfulApiNames<T>(
  results: PromiseSettledResult<T>[],
  names: LoginApiName[],
) {
  return results.reduce<LoginApiName[]>((successfulApis, result, index) => {
    if (result.status === 'fulfilled') successfulApis.push(names[index]);
    return successfulApis;
  }, []);
}

export function getPhoneEndpoint(
  isMedico: boolean,
  normalizedLogin: string,
  action: 'exists' | 'register',
) {
  const entity = isMedico ? 'medico' : 'paciente';

  return action === 'exists'
    ? `/v2/${entity}/${normalizedLogin}/telefone-existe`
    : `/v2/${entity}/telefone`;
}

export function buildPhonePayload({
  isMedico,
  login,
  password,
  ddd,
  number,
}: {
  isMedico: boolean;
  login: string;
  password: string;
  ddd: string;
  number: string;
}) {
  const normalizedLogin = login.replace(/\D/g, '');

  if (isMedico) {
    return {
      CD_PRESTADOR: normalizedLogin,
      CPF: password.replace(/\D/g, ''),
      NR_DDD_CELULAR: ddd,
      NR_CELULAR: number,
    };
  }

  return {
    DOCUMENTO: normalizedLogin,
    DT_NASCIMENTO: password.trim(),
    NR_DDD_CELULAR: ddd,
    NR_CELULAR: number,
  };
}
